import api from '../utils/api';
import { logError } from '@zg-rentals/log-error';

const StaticMapActions = {
  signUrl(url, params) {
    return (dispatch) =>
      dispatch(api.users.signUrl(url, params))
        .then((response) => {
          if (response.success === false) {
            // error
            return Promise.reject({
              message: `ERROR: Request to sign url @ ${url}`,
            });
          }
          // success
          return response.signedUrl;
        })
        .catch((error) =>
          logError({
            error,
            context: 'StaticMapActions.signUrl',
          }),
        );
  },
};

export default StaticMapActions;
